require("./SelectPackage.marko.css");
"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_classValue = require("marko/dist/runtime/helpers/class-value"),
    marko_component = {
    onCreate: function ({accountType}) {
        this.state = { list: [] };
        GState.bind(this, [
            'tenant',
            'user'
        ]);
        const acctype = accountType || this.state.user.accounttype;
        this.state.tenant.settings.pricing && this.state.tenant.settings.pricing && this.state.tenant.settings.pricing[acctype] && this.state.tenant.settings.pricing[acctype].enabled && this.setState({ list: this.state.tenant.settings.pricing[acctype].packages });
    },
    onSelect: function (name) {
        this.emit('select', name);
    },
    onSelectAll: function () {
        this.emit('select-all', this.state.list);
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/components/SelectPackage.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    Bx_template = require("../../components/Bx/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Bx_tag = marko_loadTag(Bx_template),
    Locale_template = require("../../components/Locale/index.marko"),
    Locale_tag = marko_loadTag(Locale_template),
    marko_forOf = require("marko/dist/runtime/helpers/for-of"),
    marko_attrs0 = {
        "class": "font-medium-2 cursor-pointer nav-item px-2 py-50"
      },
    marko_attrs1 = {
        "class": "font-medium-2 cursor-pointer nav-item px-2 py-50"
      },
    marko_attrs2 = {
        "class": "text-center p-1"
      };

function render(input, out, __component, component, state) {
  var data = input;

  out.be("div", {
      "class": marko_classValue(marko_classValue([
        "btn-group dropdown",
        input.class
      ]))
    }, "0", component, null, 1);

  if (!input.decoupled) {
    out.be("button", {
        type: "button",
        "class": marko_classValue((("btn " + (input.btnType || "theme-bg-lighten")) + " py-50 align-middle rounded ") + (input.disabled ? " disabled" : "")),
        "data-toggle": !input.disabled ? "dropdown" : ""
      }, "1", component);

    Bx_tag({
        type: "plus",
        class: "font-medium-3 white-text float-left"
      }, out, __component, "2");

    Locale_tag({
        text: input.label || "Add",
        class: "font-medium-3"
      }, out, __component, "3");

    out.ee();
  }

  out.be("ul", {
      "class": marko_classValue(((("dropdown-menu border theme-bg py-0 " + (input.position ? " dropdown-menu-" + input.position : "")) + " ") + (input.decoupled ? "show" : "")) + " overflow-auto"),
      style: "max-height:25rem"
    }, "4", component, null, 1);

  if (Array.isArray(state.list) && state.list.length) {
    if (input.selectAll) {
      out.e("li", marko_attrs0, "5", component, 1, 0, {
          onclick: __component.d("click", "onSelectAll", false)
        })
        .t("All");
    }

    marko_forOf(state.list, function(each, index) {
      out.e("li", marko_attrs1, "@" + ("package-" + index), component, 1, 0, {
          onclick: __component.d("click", "onSelect", false, [
              each
            ])
        })
        .t(each.toCapitalCase(), component);
    });
  } else {
    out.be("div", marko_attrs2, "6", component);

    Locale_tag({
        renderBody: function(out) {
          out.t("No Package Found");
        }
      }, out, __component, "7");

    out.ee();
  }

  out.ee();

  out.ee();
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
